/**
 * tdesign v0.46.2
 * (c) 2022 tdesign
 * @license MIT
 */

'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var merge = require('lodash/merge');
var _mergeWith = require('lodash/mergeWith');
var _common_js_globalConfig_defaultConfig = require('../_common/js/global-config/default-config.js');
var _common_js_globalConfig_locale_zh_CN = require('../_common/js/global-config/locale/zh_CN.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var merge__default = /*#__PURE__*/_interopDefaultLegacy(merge);
var _mergeWith__default = /*#__PURE__*/_interopDefaultLegacy(_mergeWith);

var EAnimationType = /* @__PURE__ */function (EAnimationType2) {
  EAnimationType2["ripple"] = "ripple";
  EAnimationType2["expand"] = "expand";
  EAnimationType2["fade"] = "fade";
  return EAnimationType2;
}(EAnimationType || {});
var defaultGlobalConfig = merge__default["default"](_common_js_globalConfig_defaultConfig["default"], _common_js_globalConfig_locale_zh_CN["default"]);
var mergeWith = function mergeWith(defaultGlobalConfig2, injectConfig) {
  return _mergeWith__default["default"](defaultGlobalConfig2, injectConfig, function (objValue, srcValue) {
    if (Array.isArray(objValue)) {
      return srcValue;
    }
  });
};

exports.EAnimationType = EAnimationType;
exports.defaultGlobalConfig = defaultGlobalConfig;
exports.mergeWith = mergeWith;
//# sourceMappingURL=context.js.map
